import * as React from "react";
import Image from "next/image";
import { styled } from "@mui/system";
import { Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import planImg from "../../../../assets/imgs/main-website/Illustration-plan.svg";
import createImg from "../../../../assets/imgs/main-website/Illustration-create.svg";
import lunchImg from "../../../../assets/imgs/main-website/Illustration-launch.svg";
import styles from "./HowToStartTabs.module.css";

function CustomTabPanel(props) {
  const theme = useTheme();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Box
            sx={{
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "& img": {
                width: "50%",
              },
              "& p": {
                width: "65%",
                fontWeight: "300",
              },
              "& b": {
                fontWeight: "600",
              },
              [theme.breakpoints.down("sm")]: {
                flexDirection: "column-reverse",
                "& img": {
                  width: "100%",
                },
                "& p": {
                  width: "100%",
                  fontWeight: "300",
                },
              },
            }}
          >
            {children}
          </Box>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const HowToStartTabs = (props) => {
  const { redirectToForm, getStartedHandler } = props;

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          // backgroundColor: 'rgba(255, 255, 255, 0.5)',
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          //   backdropFilter: "blur(10px)",
          //   zIndex: 1,
        }}
      >
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Plan" {...a11yProps(0)} />
          <Tab label="Create" {...a11yProps(1)} />
          <Tab label="Launch" {...a11yProps(2)} />
        </StyledTabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <div className={styles.howtoStart}>
          <p>
            <i style={{ display: "block", marginBottom: "10px" }}>
              Your Journey Begins with Your Expertise.{" "}
            </i>
            Begin your teaching journey by sharing what you know best and love
            most. Your teaching approach and curriculum is entirely yours to
            define and develop as you see fit.
          </p>
          <b>How we can help you</b>
          <p>
            Our 'Teaching Resource and Success Team (TRST)' is here to team up
            with you in planning and discussing the subject. In addition, we
            provide multiple resources to help you create your first course.
          </p>
          <StyledButton variant="contained" onClick={(e) => getStartedHandler()}>
            Get Started
          </StyledButton>
        </div>
        <Image src={planImg} alt="section image" />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div className={styles.howtoStart}>
          <p>
            <i style={{ display: "block", marginBottom: "10px" }}>
              Turn Your Passion into Reality.
            </i>
            Create your own curriculum and sessions with 1-2 minutes previews.
            Run your live-sessions or use your pre-recorded videos. Basic
            recording tools such as a smartphone or DSLR camera are all you
            need. For better audio, add a quality microphone, and you're set to
            create your course.
          </p>
          <p>
            If being on camera isn't your preference, screen capture works just
            as well. For a paid course, we recommend a minimum of two hours of
            video content.
          </p>
          <b>How we can help you</b>
          <p>
            Our dedicated Teaching Resource and Success Team (TRST) is available
            for you every step of the way. We provide guidance and feedback on
            your course test videos.
          </p>
          <p>
            With professional-grade equipment, we can even send our team to your
            location, collaborating to record your entire course, ensuring
            high-quality videos, optimal lighting, and a seamless production
            process.
          </p>
          <StyledButton variant="contained" onClick={(e) => getStartedHandler()}>
            Get Started
          </StyledButton>
        </div>
        <Image src={createImg} alt="section image" />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <div className={styles.howtoStart}>
          <p>
            <i style={{ display: "block", marginBottom: "10px" }}>
              Going Live is Super Easy.
            </i>
            Each course receives a unique URL for easy sharing on social media.
            Promote your course to gain initial ratings and reviews across
            social media and professional networks. As your course gains
            visibility on our platform, you start earning revenue from every
            paid enrollment.
          </p>
          <p>
            Additionally, create promotions and coupons to further boost course
            visibility.
          </p>
          <b>How we can help you</b>
          <p>
            Our Teaching Resource and Success Team (TRST) assists in marketing,
            sharing tips and promoting your course to reach a broader audience.
            Utilize worldwide promotions to expand your course reach and achieve
            success.
          </p>
          {/* <StyledButton variant="contained" onClick={(e) => getStartedHandler()}>
            Get Started
          </StyledButton> */}
        </div>
        <Image src={lunchImg} alt="section image" />
      </CustomTabPanel>
    </Box>
  );
};

export default HowToStartTabs;

const StyledTabs = styled(Tabs)(({ theme }) => ({
  marginTop: "20px",
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  backdropFilter: "blur(10px)",
  borderRadius: "1000px",
  zIndex: 1,
  "& .MuiButtonBase-root": {
    padding: "1.5rem 5rem",
    color: "#fff",
  },
  "& .MuiButtonBase-root.Mui-selected": {
    padding: "1.5rem 5rem",
    color: "#004FE0",
    backgroundColor: "#fff",
    borderRadius: "1000px",
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "&:hover": {},
  [theme.breakpoints.down("sm")]: {
    "& .MuiButtonBase-root": {
      padding: ".5rem 1.6rem",
    },
    "& .MuiButtonBase-root.Mui-selected": {
      padding: ".5rem 1.6rem",
    },
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: "10px !important",
  padding: "14px 46px !important",
  background: "#fff !important",
  color: "#004FE0 !important",
  boxShadow: "none !important",
  borderRadius: "10px !important",
  "&:hover": {
    background: "#fff !important",
    boxShadow: "none !important",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100% !important",
  },
}));
